// Module
var code = "<h1 id=\"leave\">Leave</h1> <p>This is where the tenant leave structure is setup with types of leave, accrual rate, and annual leave carry over</p> ";
// Exports
module.exports = code;